export default {"src":"/_next/static/media/color-swatch.2605b732.svg","height":24,"width":24};